import React from 'react';

function TextInput({ name, disabled, displayName, defaultValue, onChange }) {
  return (
    <div className="form-group">
      <label htmlFor={name}>{displayName}</label>
      <input
        type="text"
        id={name}
        disabled={disabled}
        className="form-control"
        value={defaultValue}
        onChange={({ target: { value } }) => onChange(value)}
      />
    </div>
  );
}

export default TextInput;
